/**
 * Subscription utility functions for feature gating and access control
 */

/**
 * Safely converts an ISO date string to a Date object.
 */
export const toSafeDate = (val: string | undefined | null): Date | null => {
  if (!val) return null;
  const d = new Date(val);
  return isNaN(d.getTime()) ? null : d;
};



/**
 * Format price in cents to display string
 * @param cents Price in cents
 * @param currency Currency code (default: 'USD')
 * @returns Formatted price string (e.g., '$4.99')
 */
export function formatPrice(cents: number, currency: string = 'USD'): string {
  if (cents === 0) return 'Free';

  const dollars = cents / 100;
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  });

  return formatter.format(dollars);
}



/**
 * Check if a user is an admin
 * @param role User's role
 * @returns True if user is an admin
 */
export function isAdmin(role: string | undefined): boolean {
  return role === 'admin';
}

/**
 * Get monthly cycle string for subscription billing period
 * @param startDateValue Subscription start date
 * @returns Billing cycle string formatted as YYYY-MM
 */
export function getSubscriptionMonthKey(startDateValue: string | undefined): string {
  const startDate = startDateValue ? new Date(startDateValue) : new Date();

  const now = new Date();
  const startDay = startDate.getDate();
  let cycleMonth = now.getMonth();
  let cycleYear = now.getFullYear();

  if (now.getDate() < startDay) {
    cycleMonth--;
    if (cycleMonth < 0) {
      cycleMonth = 11;
      cycleYear--;
    }
  }

  const monthStr = String(cycleMonth + 1).padStart(2, '0');
  return `${cycleYear}-${monthStr}`;
}

